import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import TradeTicketApp, { isTradePath } from './trade/TradeTicketApp.jsx';
import { isReportsPath } from './reports/path.js';
import { isNotesPath } from './notes/path.js';
import { DEV_ONLY } from './env.js';
import { keepPasswordManagersOut } from './utils/passwordManagers.js';
import './styles.css';
import './presentation.css';
import './plan.css';
import './planning.css';
import './assessment.css';
import './zoom.css';

// The trade ticket is its own part of the app under /trade, with nothing to do
// with the PQ store (src/trade/TradeTicketApp.jsx). It is held to dev
// (src/env.js) until Investment Management's pilot approves it.
const TRADE = DEV_ONLY && isTradePath(window.location.pathname);

// The planning reports are their own part of the app under /reports, the
// YCharts stand-in for the Morningstar reports (src/reports/). Held back from
// production, and held to dev (src/env.js), until Planning has used them
// alongside Morningstar.
const REPORTS = DEV_ONLY && isReportsPath(window.location.pathname);
// Loaded only on /reports, so its styles (including its @page print margins)
// never reach the PQ's own screens or printouts.
const PlanningReportsApp = React.lazy(() => import('./reports/PlanningReportsApp.jsx'));

// Strategy notes, version 1, are their own part of the app under /notes: the
// planner's stage 7 households and the finishing of Gavel's notes file in the
// browser (src/notes/). Held to dev (src/env.js) until the pilot planners
// have used it. Loaded only on /notes, like /reports. Unlike /reports, a build
// for anywhere else does not carry the chunk at all: the lazy import sits
// behind the same test as DEV_ONLY, spelled out from the values Vite fixes at
// build time, because Rollup cannot see through DEV_ONLY's Boolean() to drop
// it (other builds still ship the /reports chunk, unreachable).
const NOTES_BUILD = import.meta.env.DEV || import.meta.env.VITE_APP_ENV === 'dev';
const NOTES = NOTES_BUILD && DEV_ONLY && isNotesPath(window.location.pathname);
const NotesApp = NOTES_BUILD ? React.lazy(() => import('./notes/NotesApp.jsx')) : null;

// No field in the app is a login, so password managers are kept out of all of
// them (utils/passwordManagers.js), including the notes popovers on <body>.
keepPasswordManagersOut(document.body);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {TRADE ? <TradeTicketApp />
      : REPORTS ? <React.Suspense fallback={null}><PlanningReportsApp /></React.Suspense>
      : NOTES ? <React.Suspense fallback={null}><NotesApp /></React.Suspense>
      : <App />}
  </React.StrictMode>
);
